import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router';


Vue.config.productionTip = false

export const APIBASE = process.env.NODE_ENV=='production'? '/api/wms' : '/wms';

Vue.use(ElementUI);

new Vue({
  router,
  el: '#app',
  render: h => h(App),
}).$mount('#app')
